import { mutatorAction } from 'satcheljs';
import getStore from '../store';

const resetWasDismissedMutator: () => void = mutatorAction(
    'resetReplyNudgeWasDismissed',
    (): void => {
        const store = getStore();
        store.wasDismissed = false;
    }
);

export default resetWasDismissedMutator;
